import { useIdAttribute as g, useControlAttributes as C, useProxyModelValue as V } from "@onereach/ui-components-common/hooks";
import { isArray as m, isUndefined as c, include as $, exclude as w } from "@onereach/ui-components-common/utils";
import { O as B, L as O } from "./OrLabel-K7_HgvcK.mjs";
import { defineComponent as S, reactive as q, ref as k, computed as d, toRef as L, resolveComponent as E, openBlock as b, createElementBlock as A, normalizeClass as N, createElementVNode as P, mergeProps as T, createBlock as j, withCtx as f, renderSlot as h, createTextVNode as z, toDisplayString as D, createCommentVNode as F } from "vue";
import { _ as H } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const I = [
  // Layout
  "layout-row",
  // Spacing
  "md:gap-sm"
], M = [
  // Layout
  "layout-inline-row justify-center",
  // Interactivity
  "interactivity-click",
  // Shape
  "rounded-sm leading-[0]",
  // Box
  "w-md+ md:w-md",
  "h-md+ md:h-md",
  "m-[10px] md:m-none",
  // Iconography
  "iconography-outlined",
  // Theme
  "appearance-none",
  "theme-preset-3-primary",
  "dark:theme-preset-3-primary-dark",
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-border-outline border-1",
  "dark:theme-border-outline-dark",
  // Theme (focus)
  "focus-visible:theme-outline-primary focus-visible:outline-2",
  "dark:focus-visible:theme-outline-primary-dark",
  // Theme (checked)
  "checked:theme-preset-1-primary",
  "dark:checked:theme-preset-1-primary-dark",
  // Theme (indeterminate)
  "indeterminate:theme-preset-1-primary",
  "dark:indeterminate:theme-preset-1-primary-dark",
  // Theme (read-only)
  "read-only:theme-border-outline",
  "read-only:dark:theme-border-outline-dark",
  "checked:read-only:theme-background-base",
  "checked:read-only:dark:theme-background-base-dark",
  "checked:read-only:theme-foreground-outline",
  "checked:read-only:dark:theme-foreground-outline-dark",
  "indeterminate:read-only:theme-background-base",
  "indeterminate:read-only:dark:theme-background-base-dark",
  "indeterminate:read-only:theme-foreground-outline",
  "indeterminate:read-only:dark:theme-foreground-outline-dark",
  // Interactivity
  "interactivity-click",
  // Interactivity (read-only)
  "read-only:interactivity-none"
], R = [
  // Content (checked / children)
  "after:checked:content-checkbox-checked",
  // Content (indeterminate / children)
  "after:indeterminate:content-checkbox-indeterminate"
], U = S({
  name: "OrCheckbox",
  components: {
    OrLabel: B
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    value: {
      type: void 0,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    labelVariant: {
      type: String,
      default: () => O.Toggle
    },
    indeterminate: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "change",
    "click",
    "focus",
    "blur"
  ],
  expose: [
    "root",
    "focus",
    "blur"
  ],
  setup(e, o) {
    const l = q({
      id: g(),
      ...C()
    }), i = k(), u = d(() => [
      "or-checkbox-v3",
      ...I
    ]), a = k(), n = d(() => [
      ...M,
      ...R
    ]), r = V(L(e, "modelValue"), o.emit), s = d(() => {
      if (m(r.value)) {
        if (c(e.value))
          throw new Error("[OrCheckbox]: `value` must be specified.");
        return r.value.includes(e.value);
      }
      return !!r.value;
    });
    function y() {
      if (m(r.value)) {
        if (c(e.value))
          throw new Error("[OrCheckbox]: `value` must be specified.");
        s.value ? r.value = w(e.value, r.value) : r.value = $(e.value, r.value);
      } else
        r.value = !r.value;
    }
    function p() {
      var t;
      (t = a.value) == null || t.focus();
    }
    function v() {
      var t;
      (t = a.value) == null || t.blur();
    }
    return {
      attributes: l,
      root: i,
      rootStyles: u,
      control: a,
      controlStyles: n,
      checked: s,
      onChange: y,
      focus: p,
      blur: v
    };
  }
}), G = ["checked", ".indeterminate", "required", "disabled", "readonly"];
function J(e, o, l, i, u, a) {
  const n = E("OrLabel");
  return b(), A("div", {
    ref: "root",
    class: N(e.rootStyles)
  }, [
    P("input", T({ ref: "control" }, e.attributes, {
      class: e.controlStyles,
      type: "checkbox",
      checked: e.checked,
      ".indeterminate": e.indeterminate,
      required: e.required,
      disabled: e.disabled,
      readonly: e.readonly,
      onChange: o[0] || (o[0] = (r) => {
        e.$emit("change", r), e.onChange();
      }),
      onClick: o[1] || (o[1] = (r) => e.$emit("click", r)),
      onFocus: o[2] || (o[2] = (r) => e.$emit("focus", r)),
      onBlur: o[3] || (o[3] = (r) => e.$emit("blur", r))
    }), null, 16, G),
    e.$slots.default || e.label ? (b(), j(n, {
      key: 0,
      "control-id": e.attributes.id,
      variant: e.labelVariant,
      selected: e.checked,
      required: e.required,
      disabled: e.disabled,
      readonly: e.readonly
    }, {
      addon: f(() => [
        h(e.$slots, "addon")
      ]),
      default: f(() => [
        h(e.$slots, "default", {}, () => [
          z(D(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["control-id", "variant", "selected", "required", "disabled", "readonly"])) : F("", !0)
  ], 2);
}
const Z = /* @__PURE__ */ H(U, [["render", J]]);
export {
  Z as O
};
//# sourceMappingURL=OrCheckbox-WPBzlvaV.mjs.map
